import { Component, Input } from '@angular/core';
import { DEFAULT_DATE_TIME_FORMAT } from 'src/app/core/ccomx-date-formats';

@Component({
  selector: 'app-document-revisions-template',
  templateUrl: './document-revisions-template.component.html',
  standalone: false,
})
export class DocumentRevisionsTemplateComponent {
  @Input() columnName: string;
  @Input() element: any;
  dateFormat = DEFAULT_DATE_TIME_FORMAT.replace(' ', ' - ');
}
